import Pdf from "./Pdf";

export default Pdf;
